import { useUpdatePurchasesPermissions } from 'src/components/Purchases/BulkActions/useUpdatePurchasesPermissions';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkUpdateDeliveryType = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const { hasPurchaseUpdateDeliveryTypePermission } =
    useUpdatePurchasesPermissions();

  if (!hasPurchaseUpdateDeliveryTypePermission) {
    return null;
  }

  return (
    <>
      <PosDropdownItem
        key="update-delivery-type-event-purchases"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <Content id={ContentId.UpdateDeliveryType} />
        </Stack>
      </PosDropdownItem>
    </>
  );
};
